









































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import CustomersDropdown from "./CustomersDropdown.vue";
import { Order } from "@/models/order/order";
import { mixins } from "vue-class-component";
import { Auth } from "@/mixins/auth";
import AuthService from "@/services/auth_service";
import { Mobile } from "@/mixins/mobile";
import { EventBus } from "@/event-bus";

@Component({
  components: {
    CustomersDropdown
  },
  directives: {
    "click-outside": {
      bind(el: any, binding: any) {
        el._clickOutside = (e: Event) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener("click", el._clickOutside);
      },
      unbind(el: any) {
        document.removeEventListener("click", el._clickOutside);
      }
    }
  } // kept for account dropdown
})
export default class Header extends mixins(Auth, Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetAssignedCustomer))
  customer!: string;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  order!: Order;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearCustomer))
  clearCustomer!: () => Promise<void>;
  protected menuIsOpen = false;
  protected authService = new AuthService();

  protected showNewQuoteModal = false;
  protected showCustomerDropdown = false;
  protected showAccountDropdown = false;

  protected toggleCustomerDropdown(): void {
    this.showCustomerDropdown = !this.showCustomerDropdown;
  }

  protected closeCustomerDropdown(): void {
    this.showCustomerDropdown = false;
  }

  protected toggleAccountDropdown(): void {
    this.showAccountDropdown = !this.showAccountDropdown;
  }

  protected closeAccountDropdown(): void {
    this.showAccountDropdown = false;
  }

  protected toggleSidebar(): void {
    this.menuIsOpen = !this.menuIsOpen;
    EventBus.$emit("toggleSidebar");
  }

  mounted() {
    EventBus.$on("sidebarClosed", () => {
      this.menuIsOpen = false;
    });
    EventBus.$on("openCustomerModal", () => {
      this.showCustomerDropdown = true;
    });
  }

  beforeDestroy() {
    EventBus.$off("sidebarClosed");
    EventBus.$off("openCustomerModal");
  }

  get isReviewPage(): boolean {
    return this.$route.name === "OrderReview";
  }

  get totalQty(): number {
    let qty = 0;
    if (this.order.items && this.order.items.length) {
      for (const item of this.order.items) {
        qty = qty + item.qty;
      }
    }
    return qty;
  }

  public async logout(): Promise<void> {
    try {
      this.setLoggedIn(false);
      this.setUserRole(null);
      this.setAuthToken(null);
      this.setImpersonation(null);
      await this.authService.logout();
      const callback = `${process.env.VUE_APP_URL}/auth/callback`;
      const loginUrl = `${process.env.VUE_APP_API_LARAVEL_URL}/auth/login?redirect=${encodeURIComponent(callback)}&app=${process.env.VUE_APP_SSO_APP_SLUG}`;
      window.location.replace(
        `${process.env.VUE_APP_API_LARAVEL_URL}/auth/logout?redirect=${encodeURIComponent(loginUrl)}`
      );
    } catch (err) {
      // On error, still redirect to login
      window.location.replace("/login");
    }
  }
}
